/**
 * 常用正则表达式
 */
export const regExps = {
    /** url校验 */
    url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
    /** email校验 */
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    /** 身份证号校验 */
    idCard: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/,
    /** 英文字母、数字 组成的字符串校验 */
    letterOrNum: new RegExp('^[0-9a-zA-Z]+$'),
    /** 英文字母、数字、_ 组成的字符串校验 */
    letterOrNum_: new RegExp('^[0-9a-zA-Z\_]+$'),
    /** 正整数 */
    pInt: new RegExp('^[1-9]\\d*$'),
    /** 手机号 */
    phone: new RegExp('^[1][3,4,5,7,8][0-9]{9}$'),
    /** 校验是否为数字 */
    number: /^[+-]?(([1-9]\d*)|([1-9]\d*\.\d*)|(0\.\d*)|(0))$/,
    /** 校验是否为整数 */
    int: /^[+-]?\d+$/,
    /** 校验是否为手机号或者座机号 */
    phoneOrTel: /^([0]\d{2,3}[-]?\d{7,8})|[4,8]00[-]?[0-9]{7}|([1][3,4,5,7,8][0-9]{9})$/
};
/**
 * 校验URL地址是否正确
 * @param url
 * @returns {boolean}
 */
export function validateURL(url:string) {
    const reg = regExps.url;
    return reg.test(url);
};

/**
 * 校验email 地址是否正确
 * @param email
 * @returns {boolean}
 */
export function validateEmail(email:string) {
    const reg = regExps.email;
    return reg.test(email);
};

/**
 * 是否是身份证号
 * @param cardNo
 */
export function validateIdCardNo(cardNo:string) {
    const reg = regExps.idCard;
    return reg.test(cardNo);
};

/**
 * 检查字符串是否由英文字母、数字组成
 * @param str
 */
export function validateLetterOrNum(str:string) {
    const reg = regExps.letterOrNum;
    return reg.test(str);
};

/**
 * 检查字符串是否由英文字母、数字、下划线组成
 * @param str
 */
export function validateLetterOrNum_(str:string) {
    const reg = regExps.letterOrNum_;
    return reg.test(str);
};

/**
 * 校验是否为正整数
 * @param str
 */
export function validatePInt(str:any) {
    const reg = regExps.pInt;
    return reg.test(str);
}
/**
 * 校验是否为整数
 * @param {*} str
 */
export function validateInt(str:any) {
    const reg = regExps.int;
    return reg.test(str);
}
/**
 * 校验是否为手机号或者座机号
 */
export function validatePhoneOrTel(str:any) {
    const reg = regExps.phoneOrTel;
    return reg.test(str);
}

export default {
    isURL: validateURL,
    isEmail: validateEmail,
    isIdCardNo: validateIdCardNo,
    isLetterOrNum: validateLetterOrNum,
    isLetterOrNum_: validateLetterOrNum_,
    isPInt: validatePInt
};

